import React, { useEffect } from 'react'
import './Passenger.css'


import plane_left from '../../assets/images/Frame_237.png'
import plane_right from '../../assets/images/Frame_238.png'

import { useDispatch, useSelector } from 'react-redux'

import { getPassengers } from '../../actions/passengers.action'

import { Link } from 'react-router-dom'
import { Translate } from '../Translate/Translate'
import i18next from 'i18next'
import { API_URI } from '../../axios'


const Passenger = ({ visible }) => {

    const dispatch = useDispatch()
    const language = i18next.language

    useEffect(() => {
        dispatch(getPassengers(language))
    }, [language])

    const passengers_s = useSelector(state => state.passengers)

    const passengers = passengers_s.passengers

    const { results } = passengers

    const handle_delete = (e) => {
        if (e.length > 10) {
            return e.substring(0, 10) + "..."
        } else {
            return e.substring(0, 10)
        }
    }

    return (
        <>
            {
                results ? <div className="Passenger" id="passenger">
                    <div className="container">
                        <h4 className='text-center pb-4 fw-bold'>
                            <div className="row d-flex justify-content-center uppercase">
                                <div className="col" style={{ position: 'relative' }}>
                                    <div className={`fly ${visible == 'passenger' ? 'active_img_one' : null}`}>
                                        <img src={plane_left} alt="" className='me-2' />
                                    </div>
                                </div>
                                <Translate title='passengers' />
                                <div className="col" style={{ position: 'relative' }}>
                                    <div className={`fly_two ${visible == 'passenger' ? 'active_img_two' : null}`}>
                                        <img src={plane_right} alt="" className='ms-2' />
                                    </div>
                                </div>
                            </div></h4>
                        <div className="benefits-one__right">
                            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-3">
                                {
                                    results.map((item, index) => (
                                        <div key={index}>
                                        {item.route_type === "id" ?
                                        <Link to={`/passengers/${item.id}`} className="col item" key={item.id}>
                                        <div className="benefits-one__single w-100 h-100">
                                            <div className="benefits-one__content">
                                                <div className="benefits-one__icon">
                                                    <img src={`${API_URI}${item.icon}`} alt="" className='w-[50%] h-[160px]  object-contain' />
                                                </div>
                                                <div className="benefits-one__title">
                                                    <h3>{item.title}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </Link> :
                                    <Link to={`/passengers/${item.slug}`} className="col item" key={item.id}>
                                    <div className="benefits-one__single w-100 h-100">
                                        <div className="benefits-one__content">
                                            <div className="benefits-one__icon">
                                                <img src={`${API_URI}${item.icon}`} alt="" className='w-[50%] h-[160px]  object-contain' />
                                            </div>
                                            <div className="benefits-one__title">
                                                <h3>{item.title}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </Link> }
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div> : null
            }
        </>
    )
}

export default Passenger